export const ConsultTypeEnum = {
    AllStoreType: 1
};



// WEBPACK FOOTER //
// ./src/enuns/consultType.enum.js